import { Autocomplete } from '@hopskipdrive/react-components';
import { MenuItem } from '@mui/material';
import styled from 'styled-components';

import { colorTokens } from '../../../shared/components/variables';

export const StyledAutocomplete = styled(Autocomplete)`
  && {
    .MuiInputBase-root {
      flex-wrap: nowrap;
      max-height: none;
    }
  }
` as typeof Autocomplete;

export const StyledIncidentSubClassification = styled.span`
  padding: 2px 4px;
  background-color: ${colorTokens.chip.light};
  border: 1px solid ${colorTokens.chip.border};
  border-radius: 4px;
  text-wrap: wrap;
  color: ${colorTokens.primary.main};
  font-weight: 500;
`;

export const IncidentItem = styled(MenuItem)`
  && {
    padding: 4px 12px;
    align-items: flex-start;

    &:hover {
      background-color: ${colorTokens.primary.hover}!important;
    }

    &[aria-selected='true'],
    &.selected {
      background-color: ${colorTokens.primary.selected};
    }
  }
`;
